<template>
  <div class="sportPage">
    <div class="main-news-wrapper">
      <div class="inner" ref="inner">
        <defaultBar
          v-if="latestNews.length > 0"
          :list="latestNews[0][0]"
        ></defaultBar>
        <div
          ref="opacityBlock"
          style="height: calc(100vh - 187px); width: 100%; transition: all 0.6s ease"
        ></div>
        <div
          class="anim-effect"
          :class="addClassActive ? 'inactive' : ''"
          ref="animEffect"
        >
          <div class="overlay-sport"></div>
          <FootbalTournaments :bottom="addClassActive" ref="footbalCarusel" />
          <template v-for="(list, index) in latestNews" :key="index">
            <component
              :is="
                list.length !== pageSize
                  ? 'universalList'
                  : `bar${index.toString().substr(-1)}`
              "
              :list="index - 1 === -1 ? list.slice(1, list.length) : list"
              transition-mode="out-in"
            />
          </template>
        </div>
      </div>
      <div
        v-if="show.spinner"
        style="
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 44px 0;
        "
        :style="{ height: latestNews.length > 0 ? 'unset' : '80vh' }"
      >
        <div class="lds-spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref,
  computed,
  reactive,
  onMounted,
  onBeforeUnmount,
  watch
} from "vue";
import AdditionalBar from "@/components/AdditionalBar";
import MainBar from "@/components/sport/MainBar";
import FootbalTournaments from "@/components/sport/FootbalTournaments";
import FirstBar from "@/components/sport/FirstBar";
import SecondBar from "@/components/sport/SecondBar";
import ThirdBar from "@/components/sport/ThirdBar";
import FourthBar from "@/components/sport/FourthBar";
import FivthBar from "@/components/sport/FivthBar";
import { useStore } from "vuex";
import { useInfiniteScroll } from "@/utils/infiniteScroll";
import { useLanguage } from "@/utils/language";
import Header from "@/components/Header";

export default {
  components: {
    defaultBar: MainBar,
    FootbalTournaments,

    universalList: AdditionalBar,

    bar0: FirstBar,
    bar1: SecondBar,
    bar2: ThirdBar,
    bar3: FourthBar,
    bar4: FivthBar,

    bar5: FirstBar,
    bar6: SecondBar,
    bar7: ThirdBar,
    bar8: FourthBar,
    bar9: FivthBar,
    Header
  },
  setup() {
    /* eslint-disable */
    const store = useStore();
    const inner = ref(null);
    const footbalCarusel = ref(null);
    const animEffect = ref(null);
    const show = reactive({
      topBar: true,
      spinner: true
    });
    const addClassActive = ref(true);
    const opacityBlock = ref(null);

    const { i18n } = useLanguage();

    const scrollEnd = () => {
      show.spinner = false;
    };

    const pageSize = 7;

    const { startInfiniteScroll, loadData } = useInfiniteScroll({
      wrapper: inner,
      retrieve: (load, cb) => {
        store.dispatch("getLatestNews", {
          pageSize,
          cb: () => cb(),
          category: 'sport',
          load
        });
      },
      newsCount: computed(() => store.getters.newsCount),
      currentPage: computed(() => store.getters.currentPage),
      pageSize,
      scrollEnd
    });

    const checkWidth = () => {
      show.topBar = window.innerWidth >= 993;
    };

    const animLookElem = () => {
      if (window.innerWidth > 978) {
        if (window.pageYOffset <= 50) {
          addClassActive.value = true;
          // console.log("more 978");
        } else {
          addClassActive.value = false;
        }
        opacityBlock.value.style.display = "block";
      } else {
        addClassActive.value = false;
        opacityBlock.value.style.display = "none";
        // console.log("less 978");
      }
    };

    var resizeTimeout;
    function resizeThrottler() {
      if (!resizeTimeout) {
        resizeTimeout = setTimeout(function() {
          resizeTimeout = null;
          checkWidth();
          animLookElem();

          // The checkWidth will execute at a rate of 15fps
        }, 66);
      }
    }

    const refreshData = () => {
      store.commit("flushArticleState");

      show.spinner = true;
      startInfiniteScroll();
      loadData();
    };

    refreshData()

    watch(() => i18n.global.locale.value, refreshData);
    onMounted(() => {
      window.addEventListener("resize", resizeThrottler, false);
      window.addEventListener("deviceorientation", resizeThrottler, false);
      window.addEventListener("scroll", animLookElem);
      resizeThrottler();
      animLookElem();
    });

    onBeforeUnmount(() => {
      window.removeEventListener("resize", resizeThrottler);
      window.removeEventListener("deviceorientation", resizeThrottler);
      window.removeEventListener("scroll", animLookElem);
    });

    return {
      inner,
      show,
      pageSize,
      animEffect,
      footbalCarusel,
      animLookElem,
      addClassActive,
      opacityBlock,
      latestNews: computed(() => store.getters.latestNews)
    };
  }
};
</script>

<style lang="scss" scoped>
html {
  // light;
  .sportPage {
    --date-color: rgba(255, 255, 255, 0.6);
    --category-color: rgba(255, 255, 255, 0.6);
    --primary-font-color: #fff;
    --secondary-font-color: #2a636f;
  }
  &[data-theme="dark"] {
    .sportPage {
      --date-color: rgba(255, 255, 255, 0.6);
      --category-color: rgba(255, 255, 255, 0.6);
      --primary-font-color: #fff;
      --secondary-font-color: #2a636f;
    }
  }
}

.sportPage {
  position: relative;
  height: auto;
  overflow: hidden;
  padding: 0 !important;
  // padding-bottom: 5rem;
  scroll-snap-type: y mandatory;
  .overlay-sport {
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(360deg, #2d6d77 -21.81%, #183148 100%);
    border-radius: 8px;
    @media screen and (max-width: 992px) {
      border-radius: 0px;
    }
  }
  .main-news-wrapper {
    // --collar-width: 100% !important;

    width: 100%;
    position: relative;
    background: #2a636f;

    .inner {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 3.125rem;

      .anim-effect {
        left: 0;
        // top: 0;
        border-radius: 8px;
        background: var(--secondary-font-color) !important;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        transition: all 0.4s ease-in-out;

        &.inactive {
          left: 50vw;
          // top: calc(100vh - 250px);
        }
      }
    }
  }
}
@media screen and (max-width: 1920px) {
  .sportPage {
    .main-news-wrapper {
      --collar-width: clamp(375px, 90%, 1720px);
    }
  }
}

@media screen and (max-width: 475px) {
  .sportPage {
    padding-bottom: 15rem;
    // .main-news-wrapper {
    //   .inner {
    //     .anim-effect {
    //       margin-left: 0.5rem;
    //     }
    //   }
    // }
  }
}
</style>
